// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"HomeNewsSection_cardContainer__fPV3s","cardBox":"HomeNewsSection_cardBox__iSPwh"};